export const gtmConstants = {
    events: {
        saveSeat: 'saveSeat',
        sessionCheckIn: 'sessionCheckIn',
        sessionCheckOut: 'sessionCheckOut',
        downloadAttachment: 'downloadAttachment',
        addSessionToFavourites: 'addSessionToFavourites',
        removeSessionFromFavourites: 'removeSessionFromFavourites',
        openPoll: 'openPoll',
        submitPoll: 'submitPoll',
        viewPollResults: 'viewPollResults',
        shareSpeakerLink: 'shareSpeakerLink',
        shareSessionLink: 'shareSessionLink',
        formSubmit: 'formSubmit'
    }
};

// Generic analytics payload values shared by the (non-Mixpanel) `sendAnalytics`
// events that survived the Mixpanel decommission (e.g. `sessionAccessUnauthorized`).
export const analyticsConstants = {
    sessionStatus: {
        preSession: 'preSession',
        atSession: 'atSession',
        postSession: 'postSession',
        unscheduledSession: 'unscheduledSession',
    },
    result: {
        success: 'success',
        failure: 'failure',
    },
};
